/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$('.ingredients__items .ingredient__item').hover(function(e){
  if($(window).width() > 999){
    var src = $(this).find('img.hidden').attr('src');
    var html = $(this).find('.rte_content').html();
    $('.real-ingredients .real-ingredients_left img').attr('src',src);
    $('.real-ingredients .real-ingredients_right .rte').html(html);
    $(this).closest('.ingredients__items').find('.active_text').removeClass('active_text');
    $(this).addClass('active_text')
  }
},function(e){
  if($(window).width() > 999){
    var src = $('.ingredients__items .ingredient__item:first-child').find('img.hidden').attr('src');
    var html = $('.ingredients__items .ingredient__item:first-child').find('.rte_content').html();
    $('.real-ingredients .real-ingredients_left img').attr('src',src);
    $('.real-ingredients .real-ingredients_right .rte').html(html);
    $('.ingredients__items .ingredient__item').removeClass('active_text');
    $('.ingredients__items .ingredient__item:first-child').addClass('active_text');
  }
})

$('.ingredients__items .ingredient__item').on('click',function(e){
  if($(window).width() < 1000){
    var src = $(this).find('img.hidden').attr('src');
    var html = $(this).find('.rte_content').html();
    $('.real-ingredients .real-ingredients_left img').attr('src',src);
    $('.real-ingredients .real-ingredients_right .rte').html(html);
    $(this).closest('.ingredients__items').find('.active_text').removeClass('active_text');
    $(this).addClass('active_text')
  } 
})

$(document).on('click', function (e) {
  if($(window).width() < 1000){
    if ($(e.target).closest('.ingredient__item').length === 0) {
      var src = $(this).find('img.hidden').attr('src');
      var html = $(this).find('.rte_content').html();
      $('.real-ingredients .real-ingredients_left img').attr('src',src);
      $('.real-ingredients .real-ingredients_right .rte').html(html);
      $(this).closest('.ingredients__items').find('.active_text').removeClass('active_text');
      $(this).addClass('active_text')
    }
  }
});

$('.ctm_wrapper .ctm_dropdown').on('change',function(e){
  $(this).find('option').each(function(e){
    if($(this).prop('selected')){
      var url = $(this).data('url');
      window.location.href = url;   
    }  
  })
});


$(document).on('change','.variants-checkbox .ctm_select_drop_down',function(e){
  var id =  $(this).find('option:selected').data('var-id');
  var val = $(this).val();
  var selector;
  if($(this).closest('.product__info') > 0){
    selector = $(this).closest('.product__info');
  }else{
    selector = $(this).closest('.product-form');
  }
  
  selector.find('.product-form__option-selector .block-swatch').each(function(e){
    var curr_val = $(this).find(':radio').val();
    if(curr_val == val){
      $(this).find('label')[0].click();
      
    }
  })
  
  var _checked = false;
  selector.find('.product-form__buy-buttons .rc-template .rc-radio').each(function(e){
    if($(this).find(':radio').prop('checked')){
      _checked = $(this).find(':radio').val();
    }
  })
  console.log(_checked);
  if(_checked == 'subsave'){
    var var_price = $(this).find('option:selected').data('var-price');
    var dis_price = $(this).find('option:selected').data('discount-val');
    var discount = $(this).find('option:selected').data('discount');
    var btn_text = '';
     var splt_price = 0;
     if(val.indexOf(' x ') > -1){
       var final_mul_first = parseInt(val.split('x')[0].trim());
       var final_mul_last = parseInt(val.split('x')[1].trim().split('Packs')[0].trim());
       var final = final_mul_first * final_mul_last;
       splt_price = (parseFloat(dis_price.split('$')[1]) / final).toFixed(2);
     }else{
      if(val.indexOf('8') > -1){
         splt_price = (parseFloat(dis_price.split('$')[1]) / 8).toFixed(2);
      }
       
      if(val.indexOf('14') > -1){
         splt_price = (parseFloat(dis_price.split('$')[1]) / 14).toFixed(2);
      }
      if(val.indexOf('28') > -1){
        splt_price = (parseFloat(dis_price.split('$')[1]) / 28).toFixed(2);
      }
     }
    console.log(dis_price,splt_price)
    btn_text = '<span class="origin_price">'+var_price+'</span><span class="main_price">'+dis_price+'</span> | <span class="btn_text">Add to Subscription</span>'
    $('.product-meta__price-custom').html('<span class="main_price">'+dis_price+'</span><span class="copre_price">'+var_price+'</span><span class="per_price">($'+splt_price+'/Stick)</span>');
    $('.product-form__add-button .loader-button__text').html(btn_text);
    selector.find('.rc-radio.rc-option__subsave label .rc-option__discount').text(discount+'%')
  }else{
  	var var_price = $(this).find('option:selected').data('var-price');
    var comp_price = $(this).find('option:selected').data('compare-price');
    var btn_text = '<span class="main_price">'+var_price+'</span> | <span class="btn_text">Add to Cart</span>';
       var splt_price = 0;
     if(val.indexOf(' x ') > -1){
       console.log(val);
       var final_mul_first = parseInt(val.split('x')[0].trim());
       var final_mul_last = parseInt(val.split('x')[1].trim().split('Packs')[0].trim());
       var final = final_mul_first * final_mul_last;
       splt_price = (parseFloat(var_price.split('$')[1]) / final).toFixed(2);
     }else{
       if(val.indexOf('8') > -1){
         splt_price = (parseFloat(var_price.split('$')[1]) / 8).toFixed(2);
      }
       
       if(val.indexOf('14') > -1){
        splt_price = (parseFloat(var_price.split('$')[1]) / 14).toFixed(2);
       }
       if(val.indexOf('28') > -1){
        splt_price = (parseFloat(var_price.split('$')[1]) / 28).toFixed(2);
       }
     }
    var compre_html = '<span class="main_price">'+var_price+'</span><span class="per_price">($'+splt_price+'/Stick)</span>';
    if(comp_price != var_price){
      btn_text = '<span class="origin_price">'+comp_price+'</span><span class="main_price">'+var_price+'</span> | <span class="btn_text">Add to Cart</span>'
      compre_html = '<span class="main_price">'+var_price+'</span><span class="copre_price">'+comp_price+'</span><span class="per_price">($'+splt_price+'/Stick)</span>';
    }
    if($('.product-form__add-button').prop('disabled')){
      $('.product-form__add-button .loader-button__text').html("Sold Out");  
    }else{
      $('.product-form__add-button .loader-button__text').html(btn_text);  
    }
    
    $('.product-meta__price-custom').html(compre_html)
  }
  
});

var url = window.location.href;
if(url.indexOf('/products') > -1){

  $('.ctm_rc-widget-injection-parent').remove();
  
// Select the node that will be observed for mutations
const targetNode = document.querySelector('.rc-widget-injection-parent');

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = function(mutationList, observer) {
  // Use traditional 'for loops' for IE 11
  load_price();
  
  setTimeout(function(e){
    $('.product-item__quick-form .rc-container-wrapper').each(function(e){
      $(this).remove();
    })
  },500)
  
  
  $('.product-form__buy-buttons .rc-option.rc_widget__option.rc_widget__option--subsave .rc_widget__option__selector > label').after('<span class="ctm_sub_text">Change or cancel anytime.<br> Free shipping on all orders.</span>');
  $('.product-form__buy-buttons .rc-option.rc_widget__option.rc-option__onetime .rc_widget__option__selector > label').after('<span class="ctm_sub_text">Free shipping over $45.</span>');
  // Later, you can stop observing
  observer.disconnect();
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);
}


$(document).on('change','.rc-widget-injection-parent .rc-radio :radio,.ctm_rc-widget-injection-parent .rc-radio :radio',function(e){
  load_price($(this));
})

function load_price(_this){
  var selector;
  if(_this != undefined){
      console.log(_this.closest('.product__info').length)
    if(_this.closest('.product__info').length > 0){
      selector = _this.closest('.product__info');
    }else{
      selector = _this.closest('.product-form');
    }
    var val = selector.find('.variants-checkbox .ctm_select_drop_down option:selected').val();
    console.log(selector.find('.variants-checkbox .ctm_select_drop_down option:selected'),selector)
    var _this = selector.find('.variants-checkbox .ctm_select_drop_down')
    console.log(val);
    selector.find('.product-form__option-selector .block-swatch').each(function(e){
      var curr_val = $(this).find(':radio').val();
      if(curr_val == val){
        $(this).find('label')[0].click();
  
      }
    })
    var _checked = false;
    selector.find('.product-form__buy-buttons .rc-template .rc-radio').each(function(e){
      if($(this).find(':radio').prop('checked')){
        _checked = $(this).find(':radio').val();
      }
    })
    if(_checked == 'subsave'){
     
        var var_price = selector.find('.variants-checkbox .ctm_select_drop_down option:selected').data('var-price');
        var dis_price = selector.find('.variants-checkbox .ctm_select_drop_down option:selected').data('discount-val');
        var discount = selector.find('.variants-checkbox .ctm_select_drop_down option:selected').data('discount');
        var btn_text = '';
        btn_text = '<span class="origin_price">'+var_price+'</span><span class="main_price">'+dis_price+'</span> | <span class="btn_text">Add to Subscription</span>'
        $('.product-form__add-button .loader-button__text').html(btn_text);
        var splt_price = 0;
         if(val.indexOf(' x ') > -1){
         console.log(val);
         var final_mul_first = parseInt(val.split('x')[0].trim());
         var final_mul_last = parseInt(val.split('x')[1].trim().split('Packs')[0].trim());
         var final = final_mul_first * final_mul_last;
         splt_price = (parseFloat(dis_price.split('$')[1]) / final).toFixed(2);
       }else{
        if(val.indexOf('8') > -1){
           splt_price = (parseFloat(dis_price.split('$')[1]) / 8).toFixed(2);
        }
        if(val.indexOf('14') > -1){
          splt_price = (parseFloat(dis_price.split('$')[1]) / 14).toFixed(2);
        }
        if(val.indexOf('28') > -1){
          splt_price = (parseFloat(dis_price.split('$')[1]) / 28).toFixed(2);
        }
       }
        selector.find('.product-meta__price-custom').html('<span class="main_price">'+dis_price+'</span><span class="copre_price">'+var_price+'</span><span class="per_price">($'+splt_price+'/Stick)</span>');
      console.log(selector.find('.rc-radio.rc-option__subsave label .rc-option__discount')) 
        selector.find('.rc-radio.rc-option__subsave label .rc-option__discount').text(discount+'%')
    }else{
      var var_price = selector.find('.variants-checkbox .ctm_select_drop_down option:selected').data('var-price');
      var comp_price = selector.find('.variants-checkbox .ctm_select_drop_down option:selected').data('compare-price');
      var btn_text = '<span class="main_price">'+var_price+'</span> | <span class="btn_text">Add to Cart</span>';
        var splt_price = 0;
     if(val.indexOf(' x ') > -1){
       console.log(val);
       var final_mul_first = parseInt(val.split('x')[0].trim());
       var final_mul_last = parseInt(val.split('x')[1].trim().split('Packs')[0].trim());
       var final = final_mul_first * final_mul_last;
       splt_price = (parseFloat(var_price.split('$')[1]) / final).toFixed(2);
      }else{
       if(val.indexOf('8') > -1){
         splt_price = (parseFloat(var_price.split('$')[1]) / 8).toFixed(2);
       }
        if(val.indexOf('14') > -1){
          splt_price = (parseFloat(var_price.split('$')[1]) / 14).toFixed(2);
        }
        if(val.indexOf('28') > -1){
          splt_price = (parseFloat(var_price.split('$')[1]) / 28).toFixed(2);
        }
      }
      var compre_html = '<span class="main_price">'+var_price+'</span><span class="per_price">($'+splt_price+'/Stick)</span>';
      if(comp_price != var_price){
        btn_text = '<span class="origin_price">'+comp_price+'</span><span class="main_price">'+var_price+'</span> | <span class="btn_text">Add to Cart</span>'
        compre_html = '<span class="main_price">'+var_price+'</span><span class="copre_price">'+comp_price+'</span><span class="per_price">($'+splt_price+'/Stick)</span>'
      }
      console.log(btn_text)
      selector.find('.product-form__add-button .loader-button__text').html(btn_text);
      selector.find('.product-meta__price-custom').html(compre_html);
    } 
  }else{
    if($('.product__info').length > 0){
      selector = $('.product__info');
    }else{
      selector = $('.product-form');
    }
    var val = selector.find('.variants-checkbox .ctm_select_drop_down option:selected').val();
    console.log(selector.find('.variants-checkbox .ctm_select_drop_down option:selected'),selector)
    var _this = selector.find('.variants-checkbox .ctm_select_drop_down')
    console.log(val);
    selector.find('.product-form__option-selector .block-swatch').each(function(e){
      var curr_val = $(this).find(':radio').val();
      if(curr_val == val){
        $(this).find('label')[0].click();
  
      }
    })
    var _checked = false;
    selector.find('.product-form__buy-buttons .rc-template .rc-radio').each(function(e){
      if($(this).find(':radio').prop('checked')){
        _checked = $(this).find(':radio').val();
      }
    })
    if(_checked == 'subsave'){
     
        var var_price = selector.find('.variants-checkbox .ctm_select_drop_down option:selected').data('var-price');
        var dis_price = selector.find('.variants-checkbox .ctm_select_drop_down option:selected').data('discount-val');
        var discount = selector.find('.variants-checkbox .ctm_select_drop_down option:selected').data('discount');
        var btn_text = '';
        btn_text = '<span class="origin_price">'+var_price+'</span><span class="main_price">'+dis_price+'</span> | <span class="btn_text">Add to Subscription</span>'
        $('.product-form__add-button .loader-button__text').html(btn_text);
        var splt_price = 0;
       if(val.indexOf(' x ') > -1){
         console.log(val);
         var final_mul_first = parseInt(val.split('x')[0].trim());
         var final_mul_last = parseInt(val.split('x')[1].trim().split('Packs')[0].trim());
         var final = final_mul_first * final_mul_last;
         splt_price = (parseFloat(dis_price.split('$')[1]) / final).toFixed(2);
      }else{
        if(val.indexOf('8') > -1){
         splt_price = (parseFloat(dis_price.split('$')[1]) / 8).toFixed(2);
        }
        if(val.indexOf('14') > -1){
          splt_price = (parseFloat(dis_price.split('$')[1]) / 14).toFixed(2);
        }
        if(val.indexOf('28') > -1){
          splt_price = (parseFloat(dis_price.split('$')[1]) / 28).toFixed(2);
        }
      }
        selector.find('.product-meta__price-custom').html('<span class="main_price">'+dis_price+'</span><span class="copre_price">'+var_price+'</span><span class="per_price">($'+splt_price+'/Stick)</span>');
        selector.find('.rc-radio.rc-option__subsave label .rc-option__discount').text(discount+'%')
    }else{
      var var_price = selector.find('.variants-checkbox .ctm_select_drop_down option:selected').data('var-price');
      var comp_price = selector.find('.variants-checkbox .ctm_select_drop_down option:selected').data('compare-price');
      var btn_text = '<span class="main_price">'+var_price+'</span> | <span class="btn_text">Add to Cart</span>';
        var splt_price = 0;
     if(val.indexOf(' x ') > -1){
       console.log(val);
       var final_mul_first = parseInt(val.split('x')[0].trim());
       var final_mul_last = parseInt(val.split('x')[1].trim().split('Packs')[0].trim());
       var final = final_mul_first * final_mul_last;
       splt_price = (parseFloat(var_price.split('$')[1]) / final).toFixed(2);
      }else{
       if(val.indexOf('8') > -1){
         splt_price = (parseFloat(var_price.split('$')[1]) / 8).toFixed(2);
       }
        if(val.indexOf('14') > -1){
          splt_price = (parseFloat(var_price.split('$')[1]) / 14).toFixed(2);
        }
        if(val.indexOf('28') > -1){
          splt_price = (parseFloat(var_price.split('$')[1]) / 28).toFixed(2);
        }
      }
      var compre_html = '<span class="main_price">'+var_price+'</span><span class="per_price">($'+splt_price+'/Stick)</span>';
      if(comp_price != var_price){
        btn_text = '<span class="origin_price">'+comp_price+'</span><span class="main_price">'+var_price+'</span> | <span class="btn_text">Add to Cart</span>'
        compre_html = '<span class="main_price">'+var_price+'</span><span class="copre_price">'+comp_price+'</span><span class="per_price">($'+splt_price+'/Stick)</span>'
      }
      selector.find('.product-form__add-button .loader-button__text').html(btn_text);
      selector.find('.product-meta__price-custom').html(compre_html);
    } 
  }
}


$(document).on('click','.custom_subscription .select-wrapper .combo-box__option-item',function(e){
  var val = $(this).attr('value');
  $(this).closest('.select-wrapper').find('button.select #subscribe-value').text(val);
  $(this).closest('.custom_subscription').find('> .variants-checkbox select').val(val).trigger('change');
})


$(document).ready(function () {
  $('.product-form__description .desc_read_more').click(function() {
    $('html, body').animate({
      scrollTop: $(".product-content").offset().top - 100
    }, 1000)
  });
});

$(document).on('click','.product-form__buy-buttons .ctm_item_btns_sub',function(e){
  if($(window).width() > 740){
    $(this).closest('form').find('.rc_block__type__autodeliver label')[0].click();
    $(this).closest('form').find('.main_product_trigger').trigger('click');
  }else{
    $(this).closest('.product-item').find('form .rc_block__type__autodeliver label')[0].click();
     $(this).closest('.product-item').find('form .main_product_trigger').trigger('click');
  }
})

$(document).on('click','.product-form__buy-buttons .ctm_item_btns_no_sub',function(e){
  if($(window).width() > 740){
    $(this).closest('form').find('.rc_block__type__onetime label')[0].click();
    $(this).closest('form').find('.main_product_trigger').trigger('click');
  }else{
    $(this).closest('.product-item').find('form .rc_block__type__onetime label')[0].click();
    $(this).closest('.product-item').find('form .main_product_trigger').trigger('click');
  }
})
 
$('.product-item__info .mobile_btn_wrap button.ctm_no_sub_btn').on('click',function(e){
  $(this).closest('.product-item').find('.product-item__image-wrapper form button[type="submit"]')[0].click();
})

$('.product-item__quick-form .ctm_item_btns_sub').on('click',function(e){
  $(this).closest('form').find('.ctm_selling_plan').attr('name','selling_plan');
  $(this).closest('form').find('.main_product_trigger').trigger('click');
})

$('.product-item__quick-form .ctm_item_btns_no_sub').on('click',function(e){
  $(this).closest('form').find('.ctm_selling_plan').attr('name','');
  $(this).closest('form').find('.main_product_trigger').trigger('click');
})

$('.mobile_btn_wrap .ctm_item_btns_no_sub').on('click',function(e){
  $(this).closest('.product-item').find('form .ctm_selling_plan').attr('name','');
  $(this).closest('.product-item').find('form .main_product_trigger').trigger('click');
})

$('.mobile_btn_wrap .ctm_item_btns_sub').on('click',function(e){
  $(this).closest('.product-item').find('form .ctm_selling_plan').attr('name','selling_plan');
  $(this).closest('.product-item').find('form .main_product_trigger').trigger('click');
})

/** More recommendation **/
$(document).on('click', '.mini-cart__recommendations .product-item__quick-form .ctm_item_btns_sub', function(e){
  $(this).closest('form').find('.ctm_selling_plan').attr('name','selling_plan');
  $(this).closest('form').find('.main_product_trigger').trigger('click');
})

$(document).on('click', '.mini-cart__recommendations .product-item__quick-form .ctm_item_btns_no_sub', function(e){
  $(this).closest('form').find('.ctm_selling_plan').attr('name','');
  $(this).closest('form').find('.main_product_trigger').trigger('click');
})

$(document).on('click', '.mini-cart__recommendations .mobile_btn_wrap .ctm_item_btns_no_sub', function(e){
  $(this).closest('.product-item').find('form .ctm_selling_plan').attr('name','');
  $(this).closest('.product-item').find('form .main_product_trigger').trigger('click');
})

$(document).on('click', '.mini-cart__recommendations .mobile_btn_wrap .ctm_item_btns_sub', function(e){
  $(this).closest('.product-item').find('form .ctm_selling_plan').attr('name','selling_plan');
  $(this).closest('.product-item').find('form .main_product_trigger').trigger('click');
})

$(document).on('change','.ctm_rc-widget-injection-parent .rc-radio :radio',function(e){
  $(this).closest('.rc-template__legacy-radio').find('.rc_widget__option--active').removeClass('rc_widget__option--active rc-option--active');
  $(this).closest('.rc-radio').addClass('rc_widget__option--active rc-option--active');
  if($(this).closest('.rc-radio').hasClass('rc-option__subsave')){
    $('#selling_plan_dropdown').attr('name','selling_plan');
  }else{
    $('#selling_plan_dropdown').attr('name','');
  }
})

$(document).on('click','.shop-the-look__product-wrapper .shop-the-look__product-link,.shop-the-look__product-wrapper .shop-the-look__dot',function(e){
  var inter = setInterval(function(e) {
     if($('.drawer--quick-buy[open]').length > 0){
       quick_trigger();
       clearInterval(inter);
     }else if($('.popover--quick-buy[open]').length > 0){
       quick_trigger();
       clearInterval(inter);
     }
  },100)
})

function quick_trigger(){
  if($('.drawer--quick-buy[open]').length > 0){
    console.log('working');
    $('.drawer--quick-buy[open] .rc-radio #ctm_one_time')[0].click();
    $('.drawer--quick-buy[open] .rc-radio.rc-option__subsave #ctm_subsave')[0].click();
  }
  
  if($('.popover--quick-buy[open]').length > 0){
    console.log('working')
    $('.popover--quick-buy[open] .rc-radio #ctm_one_time')[0].click();
    $('.popover--quick-buy[open] .rc-radio.rc-option__subsave #ctm_subsave')[0].click();
    
    var _check_subscribe;
    $('.drawer--quick-buy[open] .variants-checkbox-item.has-subscribe :radio').each(function(e){
      if($(this).prop('checked')){
        _check_subscribe = true;
      }
    })
    if(_check_subscribe){
     $('.drawer--quick-buy[open]').find('form .ctm_selling_plan').attr('name','selling_plan');
    }else{
      $('.drawer--quick-buy[open]').find('form .ctm_selling_plan').attr('name','');
    }
  }
}

$(window).on('load',function(e) {
   if($('.product-form__add-button').prop('disabled')){
    $('.product-form__add-button .loader-button__text').html("Sold Out");  
   }   
  $('.prive_flex label').on('click',function(e) {
    setTimeout(function(e){
     if($('.product-form__add-button').prop('disabled')){
      $('.product-form__add-button .loader-button__text').html("Sold Out");  
     }   
    },200)  
  })
  
  $('.prive_type_box .prive_delivery_every_box .prive_select').on('change',function(e) {
    setTimeout(function(e){
     if($('.product-form__add-button').prop('disabled')){
      $('.product-form__add-button .loader-button__text').html("Sold Out");  
     }   
    },200)  
  })

  $('.prive_type_box .prive_delivery_every_box .prive_select').on('click',function(e) {
    setTimeout(function(e){
     if($('.product-form__add-button').prop('disabled')){
      $('.product-form__add-button .loader-button__text').html("Sold Out");  
     }   
    },200)  
  })
  
})